import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { MeterpointService } from "@/services/MeterpointService"
import { CancellationReasonService } from "@/services/CancellationReasonService"
import { MeterpointCancellationReason } from "@/types/MeterpointCancellationReason"

export const getMeterpointCancellationReason = (accountNumber: string) => {
  const queries = new QueryAggregator()

  const meterpointsQuery = MeterpointService.getForAccount(accountNumber)
  queries.add(meterpointsQuery)

  const cancellationReason = meterpointsQuery.data.reduce(
    (meterpointAgreementsMap, meterpoint) => {
      const query = CancellationReasonService.getForAccountMeterpoint(
        accountNumber,
        meterpoint.id,
      )
      queries.add(query)

      meterpointAgreementsMap[meterpoint.identifier] = query.data
      return meterpointAgreementsMap
    },
    {} as MeterpointCancellationReason,
  )

  return queries.setData(cancellationReason).getAggregate()
}
